import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import NewsTable from "../Common/NewsTable";
import { Link } from "react-router-dom";
import { AddPageHeader } from "../Common/Utils";

const News = () => {
  const [news, setNews] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getNews().then((data) => setNews(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("The Consular Daily Press Review")}
      <Divider align="center">
        <h1>The Consular Daily Press Review</h1>
      </Divider>
      <div className="privacy-terms">
        The Consular Daily Press Review gathers the latest major news on
        consular affairs. The Review is also accessible via the Center’s social
        networks and{" "}
        <Link
          to="/the-consular-newsletter"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          The Consular Newsletter
        </Link>
        . Are you a recognized press body? Interested in highlighting specific
        news? Please feel free to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
      <br />
      <NewsTable data={news} searchEnabled longDescription />
    </div>
  );
};

export default News;
